import NetworkComponent from './NetworkComponent';

export default NetworkComponent;
